import { useTranslation } from "react-i18next";
import SearchPlusIcon from "../../../layout/left_menu_icons/searchPlus.svg";
import { useAdvanceSearchContext } from "./AdvanceSearchContextTest";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export default function Heading() {
  const { t } = useTranslation();
  const { storedSearch } = useAdvanceSearchContext();
  let history = useHistory();
  return (
    <>
      <header className="page-header">
        <div className="header-title">
          <div className="title">
            <img src={SearchPlusIcon} alt="ni-icon" />
            {storedSearch ? (
              <h1 style={{ marginTop: "10px" }}>
                {t("Editing stored Search") + " " + storedSearch.name}
              </h1>
            ) : (
              <h1 style={{ marginTop: "10px" }}>{t("Advanced Search")}</h1>
            )}
          </div>
          <div className="subtitle">{t("Recruitment / Advanced Search")}</div>
        </div>{" "}
        <div className="text-end me-5">
          <div class="form-check form-switch">
            <input
              class="form-check-input"
              type="checkbox"
              role="switch"
              id="flexSwitchCheckDefault"
              checked={false}
              onClick={() => {
                history.push("/interview/advanceSearchOld");
              }}
            />
            <label class="form-check-label" for="flexSwitchCheckDefault">
              {t("classic")}
            </label>
          </div>
        </div>
      </header>
    </>
  );
}
